import React from "react"
import { useGetMasterAccountSummaryQuery } from "../../../services/clientsearch/masterAccountApiEndpoints"
import { useClientContext } from "../../../hooks/ClientContext"
import { useGetFactFindSummaryQuery } from "../../../services/clientfactfind"

export const ClientSummaryContext = React.createContext()

export const useClientSummaryData = () => React.useContext(ClientSummaryContext)

export const ClientSummaryProvider = ({ children }) => {
    const { id: masterAccountId } = useClientContext();
    const { data: clientSummaryData, error: clientSummaryError, isLoading: clientSummaryIsLoading } = useGetMasterAccountSummaryQuery(masterAccountId);
    const { data: factFindData, error: factFindError, isLoading: factFindIsLoading } = useGetFactFindSummaryQuery({ masterAccountId });


    return (
        <ClientSummaryContext.Provider value={{ clientSummaryData, clientSummaryError, clientSummaryIsLoading, factFindData, factFindError, factFindIsLoading }}>
            {children}
        </ClientSummaryContext.Provider>
    )
}